import { Link, useLocation } from 'react-router';

import { IntlContext } from '@utils/useIntl';
import classNames from 'classnames';
import { useContext } from 'react';
import NavItem from './NavItem';
import NavLinks from './NavLinks';
import NavMobile from './NavMobile';
import { getNavIndex, NAV_LINKS } from './utils';

const Header = () => {
  const { pathname } = useLocation();
  const { translate } = useContext(IntlContext);
  const navIndex = getNavIndex(NAV_LINKS, pathname);

  return (
    <header className="flex w-full desktop:px-8 text-2xl font-title bg-darker border-b border-gray-dark">
      {/* Desktop */}
      <nav className="max-desktop:hidden w-5/7 h-header-mobile relative flex">
        {NAV_LINKS.map(({ label, link }, index) => (
          <NavItem
            key={`${label}-${link}`}
            className={index === 0 ? 'justify-start' : 'justify-center'}
            link={link}
            selected={index === navIndex}
          >
            {typeof label === 'string' ? translate(label) : label}
          </NavItem>
        ))}
        {navIndex > -1 && (
          <div
            className={classNames(
              'absolute h-px bg-accent top-full left-0 transition-all duration-300 ease-out',
            )}
            style={{
              width: `calc(100%/${NAV_LINKS.length})`,
              left:
                navIndex === 0
                  ? 0
                  : `calc(${navIndex} * (100%/${NAV_LINKS.length}))`,
            }}
          />
        )}
      </nav>
      <NavLinks className="max-desktop:hidden grow h-header-mobile justify-end" />

      {/* Mobile */}
      <div className="desktop:hidden grow basis-0 flex items-center h-header-mobile px-4 leading-4.5 text-accent lowercase">
        <Link to="/">
          Marc
          <br />
          Malignan
        </Link>
      </div>
      <NavMobile />
    </header>
  );
};

export default Header;
